/**
 * @file コンポーネント：フル動画ページコンテンツ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Contents } from "~/src/components/projects/Video/Contents";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        // コンテンツ
        <Contents
            isOpenModalLogin={props.isOpenModalLogin}
            setIsOpenModalLogin={props.setIsOpenModalLogin}
        />
    );
};
